import React, { FC, useEffect, useRef, useState } from 'react'
import { NewsModel, selectNewsById } from '@store/slices/news.slice'
import { Button, Card, Col, Row } from 'react-bootstrap'
import {
  BsFillTrashFill,
  BsInfoCircle,
  BsPauseFill,
  BsPencil,
  BsPlayFill,
  BsQuestionCircle,
} from 'react-icons/bs'
import { AudioModel, selectAllAudios } from '@store/slices/audio.slice'
import {
  getNewsStateTranslation,
  getStateColor,
} from '../../tools/newsState.tools'
import NewsViewComponent from '@components/news/newsView.component'
import { useSelector } from 'react-redux'
import { EntityId } from '@reduxjs/toolkit'
import { RootState } from '@store/store'
import AudioPlayButton from '@components/shared/audioPlayButtonComponent'
import { formatDjangoTimeString, formatSeconds } from '../../tools/time.tools'

export interface NewsRowProps {
  newsId: EntityId
  onDeleteNews: (news: NewsModel) => void
  onEditNews: (news: NewsModel) => void
}

const NewsRow: FC<NewsRowProps> = ({ newsId, onDeleteNews, onEditNews }) => {
  const audios: AudioModel[] = useSelector(selectAllAudios)
  const news = useSelector((state: RootState) => selectNewsById(state, newsId))
  const newsAudio = audios.find((audio) => audio.id == news.audioId)

  const ActionButtons = () => (
    <div className="d-flex gap-1 align-items-center">
      <AudioPlayButton
        title={'Přehrát zprávu'}
        audioId={news.audioId}
        showSlider={false}
      ></AudioPlayButton>
      <Button
        variant="primary"
        className="fw-bold d-flex align-items-center"
        onClick={() => onEditNews(news)}
      >
        <BsPencil className="me-1"></BsPencil> Upravit
      </Button>
      <Button
        variant="danger"
        className="fw-bold"
        onClick={() => onDeleteNews(news)}
      >
        <BsFillTrashFill></BsFillTrashFill>
      </Button>
    </div>
  )
  const NoteField = () => (
    <div className={'text-secondary'}>
      <pre style={{ whiteSpace: 'pre-wrap' }}>{news.note}</pre>
    </div>
  )

  return (
    <Card
      className={`mb-2 border-${getStateColor(news.state)} bg-light-subtle`}
    >
      <Card.Header className={`bg-${getStateColor(news.state)}`}>
        <Row className="px-0 fw-bold">
          <Col className="d-flex align-items-center">{news.visualId}</Col>
          <Col className="d-flex align-items-center">{news.createdBy}</Col>
          <Col className="d-flex align-items-center">
            {getNewsStateTranslation(news.state)}
          </Col>
          <Col className="d-flex align-items-center">
            {newsAudio
              ? formatSeconds(formatDjangoTimeString(newsAudio.length))
              : '??:??'}
          </Col>
          <Col
            style={{ minWidth: '215px' }}
            className="d-flex align-items-center justify-content-end"
          >
            <ActionButtons></ActionButtons>
          </Col>
        </Row>
      </Card.Header>
      <Card.Body>
        <Row className="px-0 w-100 flex-nowrap">
          <Col
            xs={8}
            style={{ cursor: 'pointer' }}
            onClick={() => onEditNews(news)}
          >
            <NewsViewComponent news={news}></NewsViewComponent>
          </Col>
          <Col className={'border-start text-center'}>
            <NoteField></NoteField>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  )
}

export default NewsRow
